/**
 * Contractul WebSocket dintre acest frontend și gateway-ul NestJS.
 * Ținut într-un singur loc ca backend-ul să poată importa aceleași nume.
 * Descrierea completă: docs/backend-contract.md
 */
export const WS_EVENTS = {
  /** server → client: starea completă a stației, la conectare și la fiecare mesaj MQTT. */
  state: 'weather:state',
  /** server → client: eroare de aplicație (ex. brokerul MQTT e căzut). */
  error: 'weather:error',
  /** client → server: cere ultimul snapshot; răspunsul vine prin ack. */
  sync: 'weather:sync',
} as const;

export interface WsErrorPayload {
  code?: string;
  message?: string;
}
